import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdatePlanReviewRequirementMutationVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
  set: Types.Plan_Review_Requirements_Set_Input;
  submissionTypes: Array<Types.Plan_Review_Requirement_Submission_Types_Insert_Input> | Types.Plan_Review_Requirement_Submission_Types_Insert_Input;
}>;


export type UpdatePlanReviewRequirementMutation = { __typename?: 'mutation_root', delete_plan_review_requirement_submission_types?: { __typename?: 'plan_review_requirement_submission_types_mutation_response', affected_rows: number } | null, insert_plan_review_requirement_submission_types?: { __typename?: 'plan_review_requirement_submission_types_mutation_response', affected_rows: number } | null, update_plan_review_requirements_by_pk?: { __typename?: 'plan_review_requirements', id: any } | null };


export const UpdatePlanReviewRequirementDocument = gql`
    mutation updatePlanReviewRequirement($id: uuid!, $set: plan_review_requirements_set_input!, $submissionTypes: [plan_review_requirement_submission_types_insert_input!]!) {
  delete_plan_review_requirement_submission_types(
    where: {requirement_id: {_eq: $id}}
  ) {
    affected_rows
  }
  insert_plan_review_requirement_submission_types(objects: $submissionTypes) {
    affected_rows
  }
  update_plan_review_requirements_by_pk(pk_columns: {id: $id}, _set: $set) {
    id
  }
}
    `;
export type UpdatePlanReviewRequirementMutationFn = Apollo.MutationFunction<UpdatePlanReviewRequirementMutation, UpdatePlanReviewRequirementMutationVariables>;

/**
 * __useUpdatePlanReviewRequirementMutation__
 *
 * To run a mutation, you first call `useUpdatePlanReviewRequirementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlanReviewRequirementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlanReviewRequirementMutation, { data, loading, error }] = useUpdatePlanReviewRequirementMutation({
 *   variables: {
 *      id: // value for 'id'
 *      set: // value for 'set'
 *      submissionTypes: // value for 'submissionTypes'
 *   },
 * });
 */
export function useUpdatePlanReviewRequirementMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePlanReviewRequirementMutation, UpdatePlanReviewRequirementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlanReviewRequirementMutation, UpdatePlanReviewRequirementMutationVariables>(UpdatePlanReviewRequirementDocument, options);
      }
export type UpdatePlanReviewRequirementMutationHookResult = ReturnType<typeof useUpdatePlanReviewRequirementMutation>;
export type UpdatePlanReviewRequirementMutationResult = Apollo.MutationResult<UpdatePlanReviewRequirementMutation>;
export type UpdatePlanReviewRequirementMutationOptions = Apollo.BaseMutationOptions<UpdatePlanReviewRequirementMutation, UpdatePlanReviewRequirementMutationVariables>;